/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Image,
  Images,
  ImagesParams,
  ImagesRandomParams,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Images list
 */
export const images = (
    params?: MaybeRefOrGetter<ImagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Images>(
      {url: `/images`, method: 'GET',
        params, signal
    },
      );
    }




export const getImagesQueryKey = (params?: MaybeRefOrGetter<ImagesParams>,) => {
    return [
    'images', ...(params ? [params] : [])
    ] as const;
    }


export const getImagesQueryOptions = <TData = Awaited<ReturnType<typeof images>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof images>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getImagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof images>>> = ({ signal }) => images(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof images>>, TError, TData>
}

export type ImagesQueryResult = NonNullable<Awaited<ReturnType<typeof images>>>
export type ImagesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Images list
 */

export function useImages<TData = Awaited<ReturnType<typeof images>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof images>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Get a randomized List of 14 Images
 * @summary Images random list
 */
export const imagesRandom = (
    params?: MaybeRefOrGetter<ImagesRandomParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Image[]>(
      {url: `/images/random`, method: 'GET',
        params, signal
    },
      );
    }




export const getImagesRandomQueryKey = (params?: MaybeRefOrGetter<ImagesRandomParams>,) => {
    return [
    'images','random', ...(params ? [params] : [])
    ] as const;
    }


export const getImagesRandomQueryOptions = <TData = Awaited<ReturnType<typeof imagesRandom>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ImagesRandomParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof imagesRandom>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getImagesRandomQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof imagesRandom>>> = ({ signal }) => imagesRandom(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof imagesRandom>>, TError, TData>
}

export type ImagesRandomQueryResult = NonNullable<Awaited<ReturnType<typeof imagesRandom>>>
export type ImagesRandomQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Images random list
 */

export function useImagesRandom<TData = Awaited<ReturnType<typeof imagesRandom>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ImagesRandomParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof imagesRandom>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImagesRandomQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






